import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { FinishingList } from './FinishingList'
import { FinishingTouchesProps } from './types'

export const FinishingTouches: FC<FinishingTouchesProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, title, subtitle, finishing_touches }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} />
    <FinishingList finishing_touches={finishing_touches} />
  </Page>
)
